import { render } from "./TabPanel.vue?vue&type=template&id=50bc17ba"
import script from "./TabPanel.vue?vue&type=script&lang=js"
export * from "./TabPanel.vue?vue&type=script&lang=js"

import "./TabPanel.vue?vue&type=style&index=0&id=50bc17ba&lang=css"

import exportComponent from "/home/appfloretcollegein/app.floretcollege.in/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__